import { message } from "antd";
import promo from "assets/images/login/promo.png";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";

const backgroundModules = import.meta.glob("../../assets/images/login/bg[0-9]*.jpg", {
  eager: true,
  import: "default",
});

const backgrounds = Object.values(backgroundModules) as string[];

const pickBackground = () => {
  if (!backgrounds.length) return "";
  const index = Math.floor(Math.random() * backgrounds.length);
  return backgrounds[index];
};
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { userStore } from "store/userStore";
import { getTitle } from "utils";
import LoginForm from "views/Login/components/Form";
import "./styles/LoginPage.scss";

type LoginPageProps = {
  title?: string;
};

const LoginPage = observer(({ title = "" }: LoginPageProps) => {
  const [loading, setLoading] = useState(false);
  const [background] = useState(pickBackground);
  const navigation = useNavigate();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  const handleSubmit = async (form: any) => {
    setLoading(true);
    const username = form.username;
    const password = form.password;
    try {
      await userStore.login(username, password);
      await userStore.getProfile();
      permissionStore.accessRoutes = [...adminRoutes];
      console.log("userStore.info", toJS(userStore.info.role));
      if (settings.checkPermission && userStore.info.role) {
        await permissionStore.fetchPermissions(userStore.info.role.id);
        if (!permissionStore.permissions.length && !userStore.info.role.isAdmin) {
          message.error("Không có quyền truy cập");
          throw new Error("");
        }
        permissionStore.setAccessRoutes();
        navigation("/profile");
      } else {
        navigation("/profile");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" style={{ backgroundImage: background ? `url(${background})` : undefined }}>
      <div className="login-page__card">
        <div className="login-page__promo">
          <img src={promo} alt="MISA AMIS" />
        </div>
        <div className="login-page__panel">
          <div className="login-page__brand">
            <img src="/bmd-logo-bg.png" alt="BMD" className="login-page__logo" />
            <h1 className="login-page__title">Đăng nhập</h1>
          </div>
          <LoginForm loading={loading} onSubmit={handleSubmit} />
        </div>
      </div>
      <p className="login-page__copyright">Copyright © 2020 - {currentYear} BMD Solutions</p>
    </div>
  );
});

export default LoginPage;
